export default {
  setSetting(state, data) {
    state.setting = data;
  },
  setSaleSetting(state, data) {
    state.saleSetting = data;
  },

  setSaleType(state, data) {
    state.saleType = data;
  },
  setSaleTypeById(state, data) {
    state.saleTypeById = data;
  },
  setSaleTypeMaxCode(state, data) {
    state.saleTypeMaxCode = data;
  },

  setSeller(state, data) {
    state.seller = data;
  },
  setSellerById(state, data) {
    state.sellerById = data;
  },
  setSellerMaxCode(state, data) {
    state.sellerMaxCode = data;
  },

  setSalesAgents(state, data) {
    state.salesAgents = data;
  },
  setSalesAgentsById(state, data) {
    state.salesAgentsById = data;
  },
  setSalesAgentsMaxCode(state, data) {
    state.salesAgentsMaxCode = data;
  },

  setSalePricePolicy(state, data) {
    state.salePricePolicy = data;
  },
  setSalePricePolicyById(state, data) {
    state.salePricePolicyById = data;
  },
  setSalePricePolicyCommodity(state, data) {
    state.salePricePolicyCommodity = data;
  },
  setSalePricePolicyDetail(state, data) {
    state.salePricePolicyDetail = data;
  },
  setSalePricePolicyDetailById(state, data) {
    state.salePricePolicyDetailById = data;
  },
  setSalePricePolicyMaxCode(state, data) {
    state.salePricePolicyMaxCode = data;
  },

  setDiscountPolicy(state, data) {
    state.discountPolicy = data;
  },
  setDiscountPolicyById(state, data) {
    state.discountPolicyById = data;
  },
  setDiscountPolicyDetail(state, data) {
    state.discountPolicyDetail = data;
  },
  setDiscountPolicyDetailById(state, data) {
    state.discountPolicyDetailById = data;
  },
  setDiscountPolicyMaxCode(state, data) {
    state.discountPolicyMaxCode = data;
  },

  setGiftPolicy(state, data) {
    state.giftPolicy = data;
  },
  setGiftPolicyById(state, data) {
    state.giftPolicyById = data;
  },
  setGiftPolicyDetail(state, data) {
    state.giftPolicyDetail = data;
  },
  getGiftPolicyDetailById(state, data) {
    state.giftPolicyDetailById = data;
  },
  setGiftPolicyMaxCode(state, data) {
    state.giftPolicyMaxCode = data;
  },

  setExcelSample(state, data) {
    state.excelSample = data;
  },
  setExcelSampleById(state, data) {
    state.excelSampleById = data;
  },
  setExcelSampleDetail(state, data) {
    state.excelSampleDetail = data;
  },
  setExcelSampleData(state, data) {
    state.excelSampleData = data;
  },

  setPreFactor(state, data) {
    state.preFactor = data;
  },
  setPreFactorById(state, data) {
    state.preFactorById = data;
  },
  setPreFactorMaxCode(state, data) {
    state.preFactorMaxCode = data;
  },
  setPreFactorAttachment(state, data) {
    state.preFactorAttachment = data;
  },
  setPreFactorAttachmentById(state, data) {
    state.preFactorAttachmentById = data;
  },
  setPreFactorNotes(state, data) {
    state.preFactorNotes = [...data];
  },

  setSalesStatisticsByCustomersReport(state, data) {
    state.salesStatisticsByCustomersReport = data;
  },

  setSalesQuantityReport(state, data) {
    state.salesQuantityReport = data;
  },

  setCustomerSalesSingleProductReport(state, data) {
    state.customerSalesSingleProductReport = data;
  },

  setAggregatedCustomerProductSalesCustomerListReport(state, data) {
    state.aggregatedCustomerProductSalesCustomerListReport = data;
  },
  setAggregatedCustomerProductSalesCommodityListReport(state, data) {
    state.aggregatedCustomerProductSalesCommodityListReport = data;
  },

  setSaleFactor(state, data) {
    state.saleFactor = data;
  },
  setSaleFactorById(state, data) {
    state.saleFactorById = data;
  },
  setSaleFactorId(state, data) {
    state.saleFactorId = data;
  },
  setSaleFactorMaxCode(state, data) {
    state.saleFactorMaxCode = data;
  },
  setSaleFactorAttachment(state, data) {
    state.saleFactorAttachment = data;
  },
  setSaleFactorAttachmentById(state, data) {
    state.saleFactorAttachmentById = data;
  },
  setSaleNotes(state, data) {
    state.saleNotes = [...data];
  },
  setSaleFactorCommission(state, data) {
    state.saleFactorCommission = data;
  },
  setSaleFactorCommissionById(state, data) {
    state.saleFactorCommissionById = data;
  },

  setReturnSaleFactor(state, data) {
    state.returnSaleFactor = data;
  },
  setReturnSaleFactorById(state, data) {
    state.returnSaleFactorById = data;
  },
  setReturnSaleFactorId(state, data) {
    state.returnSaleFactorId = data;
  },
  setReturnSaleFactorMaxCode(state, data) {
    state.returnSaleFactorMaxCode = data;
  },
  setReturnSaleFactorAttachment(state, data) {
    state.returnSaleFactorAttachment = data;
  },
  setReturnSaleFactorAttachmentById(state, data) {
    state.returnSaleFactorAttachmentById = data;
  },
  setReturnSaleFactorNotes(state, data) {
    state.returnSaleFactorNotes = [...data];
  },
  setReturnSaleFactorCommission(state, data) {
    state.returnSaleFactorCommission = data;
  },
  setReturnSaleFactorCommissionById(state, data) {
    state.returnSaleFactorCommissionById = data;
  },

  setSaleReportByProduct(state, data) {
    state.saleReportByProduct = data;
  },

  setSalesOfficeReport(state, data) {
    state.salesOfficeReport = data;
  },

  setSaleByAgentReport(state, data) {
    state.saleByAgentReport = data;
  },
  setSaleByAgentDetailReport(state, data) {
    state.saleByAgentDetailReport = data;
  },
  setCustomerCommoditySaleReport(state, data) {
    state.customerCommoditySaleReport = data;
  },
  setCustomerCommoditySaleFactorListReport(state, data) {
    state.customerCommoditySaleFactorListReport = data;
  },
  setBasedOnSaleManagerListReport(state, data) {
    state.basedOnSaleManagerListReport = data;
  },
  setBasedOnSaleManagerDetailReport(state, data) {
    state.basedOnSaleManagerDetailReport = data;
  },
  setSalesManagerCollaborationPercentageReport(state, data) {
    state.salesManagerCollaborationPercentageReport = data;
  },
  setReportOfCreditorsAndDebtorsBasedOnSalesManagers(state, data) {
    state.reportOfCreditorsAndDebtorsBasedOnSalesManagers = data;
  },
  setCustomerSalesReportBasedOnSalesManagers(state, data) {
    state.customerSalesReportBasedOnSalesManagers = data;
  },
  setProductProfitReport(state, data) {
    state.productProfitReport = data;
  },
  setGrossProfitReport(state, data) {
    state.grossProfitReport = data;
  },
  setProductProfitByProductGroupReport(state, data) {
    state.productProfitByProductGroupReport = data;
  },
  setGrossProfitByInvoiceProductCustomerReport(state, data) {
    state.grossProfitByInvoiceProductCustomerReport = data;
  },
  setComprehensiveSalesInvoiceReport(state, data) {
    state.comprehensiveSalesInvoiceReport = data;
  },
  setComprehensiveProductSalesReport(state, data) {
    state.comprehensiveProductSalesReport = data;
  },
  setAwardsGrantedCommodityListReport(state, data) {
    state.awardsGrantedCommodityListReport = data;
  },
  setAwardsGrantedReport(state, data) {
    state.awardsGrantedReport = data;
  },
  setSaleByVisitorList(state, data) {
    state.saleByVisitorList = data;
  },
  setSaleByVisitorReport(state, data) {
    state.saleByVisitorReport = data;
  },
  setAddMinusReport(state, data) {
    state.addMinusReport = data;
  },
  setCustomerProfitReport(state, data) {
    state.customerProfitReport = data;
  },
  setFactorProfitReport(state, data) {
    state.factorProfitReport = data;
  },

  setSaleFactorManagementCartable(state, data) {
    state.saleFactorManagementCartable = data;
  },
  setSaleReturnManagementCartable(state, data) {
    state.saleReturnManagementCartable = data;
  },

  setConfirmSaleFactorCartable(state, data) {
    state.confirmSaleFactorCartable = data;
  },
  setSaleFactorGroupDraftCartable(state, data) {
    state.saleFactorGroupDraftCartable = data;
  },
  setConfirmSaleReturnCartable(state, data) {
    state.confirmsaleReturnCartable = data;
  },

  setCartableLog(state, data) {
    state.cartableLog = data;
  },

  setPrintLink(state, data) {
    state.printLink = data;
  },

  setReadPreFactor(state, data) {
    state.readPreFactor = data;
  },

  setSaleFactorVoucher(state, data) {
    state.saleFactorVoucher = data;
  },

  setReturnSaleFactorVoucher(state, data) {
    state.returnSaleFactorVoucher = data;
  },

  setReadSaleFactor(state, data) {
    state.readSaleFactor = data;
  },

  setReturnSaleFactorGroupReceiptCartable(state, data) {
    state.returnSaleFactorGroupReceiptCartable = data;
  },
};
